import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { PropsWithChildren } from 'react'
import ReactModal from 'react-modal'

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { ChevronLeftIcon } from '@flowwai-frontend/design-system/icons'
import { isMobile } from '@flowwai-frontend/shared/utils/web'

import { useMapsUIStore } from '../../hooks/useMapsUIStore'
import { useMapsUtilityContext } from '../../hooks/useMapsUtilityContext'

import './index.css'
import * as Styles from './styles'

const MapsModal = (props: PropsWithChildren): React.ReactElement => {
   const { isGeoMapModalOpen, closeGeoMapModal } = useMapsUIStore()

   const { mapsT } = useMapsUtilityContext()

   const isMobileDevice = isMobile()

   const renderBackButton = (): React.ReactElement =>
      isMobileDevice ? (
         <div className={Styles.mobileCloseIconContainerStyles}>
            <Button
               size={'Small'}
               hierarchy={Hierarchy.Link}
               subVariant={SubVariant.Primary}
               leftIcon={({ fill }) => (
                  <ChevronLeftIcon height={20} width={20} fill={fill} />
               )}
               onClick={closeGeoMapModal}
            >
               {mapsT('back')}
            </Button>
         </div>
      ) : (
         <></>
      )

   return (
      <ReactModal
         className={cn(
            Styles.modalStyles,
            isMobileDevice ? 'mobile' : '',
            isGeoMapModalOpen ? '' : 'invisible translate-y-full'
         )}
         isOpen={true}
         overlayClassName={cn(
            'maps-expanded-overlay',
            isGeoMapModalOpen ? '' : 'invisible'
         )}
      >
         {isGeoMapModalOpen ? renderBackButton() : null}

         {props.children}
      </ReactModal>
   )
}

export default observer(MapsModal)
